export const SET_PO_PREFILL = 'SET_PO_PREFILL';
export const CLEAR_PO_PREFILL = 'CLEAR_PO_PREFILL';
